export function searchSort(){
        // console.log(this)
        // console.log('触发了search')
        const {searchInp,positionArr} = this
    
        let fPersons = positionArr.filter(function(val){
            return val.postName.includes(searchInp) 
        })
        return fPersons
}

export function checkStr(str,max=0){
    let newStr = str.length>parseInt(max)?str.substr(0,parseInt(max))+'...':str
    return newStr
}

// 发送验证码倒计时
let flag = true
    export function countDwon(element,count){  // 元素  数值
       
        // return function(){
        //     if(!flag){
        //         return false
        //     }
        //     flag = false
            clearInterval(timeout)
            let elementHTML = element.innerHTML
            if(flag){

                flag = false
                 var timeout = setInterval(function(){  

                        if(count<=0){
                            clearInterval(timeout)
                            element.innerHTML = elementHTML
                            flag = true
                        }else{ 
                            count--
                            element.innerHTML=count  
                        } 
                    },1000)
            }
        
     }

// 递归遍历
                // 父数组, 属性，子数组，目标属性，返回的值
export function recursion(parentArr,attr,childArr,startAttr,returnAttr){
                let newObj = {}
                let flag = false
                // console.log('recursion111')
                // console.log(parentArr)
                // console.log(attr)
                // console.log(childArr)
                // console.log(startAttr)
                for(let i=0;i<parentArr.length;i++){
                    if(parentArr[i][childArr] && parentArr[i][childArr].length>0){
                        for(let j=0;j<parentArr[i][childArr].length;j++){
                            // console.log('值',parentArr[i][childArr][j][attr],startAttr)
                            
                            if(parentArr[i][childArr][j][attr]==startAttr){
                                // alert('11')
                                newObj = parentArr[i]
                                flag = true
                                break;
                            }else{
                                if(parentArr[i][childArr][j][childArr] && parentArr[i][childArr][j][childArr].length>0){
                                    recursion(parentArr[i][childArr][j][childArr],attr,childArr,startAttr)
                                }
                            }
                        }
                    }
                }
                if(flag){
                    console.log('obj')
                    console.log(newObj)
                    if(returnAttr){
                        return newObj[returnAttr]
                    }else{
                        return newObj
                    }
    				
                }
            }
// export function checkVal(val){
//     try{

//     }catch(){

//     }
// }

                

     export function alertBox(that,msg,status){
            that.$message({
                message: msg,
                type: status
            });
     }